import { spacing7 } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const LoadMoreWrapper = styled.div`
  margin-bottom: ${spacing7};
`;
